import { format } from "date-fns";
import api from "../infra/api";
import { getUser } from "../infra/getUser";
import { PhoneNumbers } from "../components/ModalPhones";

const phonesUrl = process.env.REACT_APP_API_URL + `api/phone`;

export type PhoneType = {
  telefone_codigo: number;
  telefone_ddd: string;
  telefone_tipo: string;
  telefone_ddi: string;
  telefone_numero: string;
  telefone_codchave: number;
  telefone_chave: string;
  telefone_ramal: string;
  telefone_contato: string;
  telefone_depto: string;
  telefone_assunto: string;
  telefone_operadora: string;
  whatsapp: any;
};

export async function getPhonesByType(
  id: number,
  type: string
): Promise<PhoneType[] | boolean> {
  try {
    const response = await api(phonesUrl + `/${id}/${type}`);

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
    return false;
  }
}

export async function insertPhone(
  codchave: number,
  type: string,
  body: PhoneNumbers
) {
  try {
    const response = await api(phonesUrl, {
      method: "POST",
      body: JSON.stringify({
        telefone_codchave: codchave,
        telefone_chave: type,
        ...body,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function updatePhone(
  id: number | undefined,
  codchave: number,
  type: string,
  body: PhoneNumbers
) {
  try {
    const response = await api(phonesUrl, {
      method: "PUT",
      body: JSON.stringify({
        telefone_codchave: codchave,
        telefone_chave: type,
        ...body,
        id: id,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export const deletePhone = async (id: number): Promise<boolean | undefined> => {
  try {
    const response = await api(phonesUrl + `/${id}`, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.ok) {
      return true;
    }
  } catch (error) {
    return false;
  }
};
